const redirects: { [key: string]: string } = {
    '/blog/daily-coffee-news-blk-bold-inks-nba-deal-releases-the-warm-up':
        '/blog',
    '/products/stocked-stickers': '/products/coffee-stickers',
    '/holiday-gifting': '/resources/design/design-lab',
};

export default redirects;
